export var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["Unauthenticated"] = "Unauthenticated";
    AuthenticationState["InProgress"] = "InProgress";
    AuthenticationState["Authenticated"] = "Authenticated";
})(AuthenticationState || (AuthenticationState = {}));
//# sourceMappingURL=AuthenticationState.js.map